export function getCsvDienstRow(csv, title) {
    const rows = csv.filter(r => r.dienst === title)
    if (rows.length === 0) {
        return {};
    }
    return rows[0];
}